import type { MachineCatalogEntry } from '@indutrust/machine-model';
import { createCrudEvents } from '@indutrust/shared-util';

/** CRUD events for the supplier-facing approved machine catalog store. */
export const machineCatalogCrudEvents =
  createCrudEvents<MachineCatalogEntry>('machine-catalog');
